import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Input,
  VStack,
  useColorModeValue
} from '@chakra-ui/react';

const SurveyPeriodForm = ({ initialData = {}, onSubmit, onCancel, isSubmitting = false }) => {
  const [formData, setFormData] = useState({
    name: '',
    key: '',
    start_date: '',
    end_date: ''
  });

  useEffect(() => {
    if (initialData?.id) {
      setFormData((prev) => ({ ...prev, ...initialData }));
    }
  }, [initialData]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const sectionBg = useColorModeValue('gray.50', 'gray.700');

  return (
    <Box maxW="container.sm" mx="auto" p={4} bg={sectionBg} borderRadius="md">
      <VStack as="form" spacing={4} onSubmit={(e) => {
        e.preventDefault();
        onSubmit(formData);
      }}>
        <FormControl isRequired>
          <FormLabel>Name</FormLabel>
          <Input
            type="text"
            value={formData.name || ''}
            onChange={(e) => handleChange('name', e.target.value)}
            placeholder="Enter display name"
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Key</FormLabel>
          <Input
            placeholder="e.g., 2025-Q1"
            value={formData.key}
            onChange={(e) => handleChange('key', e.target.value)}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>Start Date</FormLabel>
          <Input
            type="date"
            value={formData.start_date}
            onChange={(e) => handleChange('start_date', e.target.value)}
          />
        </FormControl>

        <FormControl isRequired>
          <FormLabel>End Date</FormLabel>
          <Input
            type="date"
            value={formData.end_date}
            onChange={(e) => handleChange('end_date', e.target.value)}
          />
        </FormControl>

        <Button colorScheme="green" type="submit" isLoading={isSubmitting}>
          Save Period
        </Button>

        {onCancel && (
          <Button variant="outline" onClick={onCancel}>
            Cancel
          </Button>
        )}
      </VStack>
    </Box>
  );
};

export default SurveyPeriodForm;